import Vue from 'vue'
import vuex, {Store} from 'vuex'
// import httpUtil from '../assets/script/utils/http'
import core from "./core"
import user from "./user"
import menu from "./menu"
import wordfre from "./wordfrequency"
import course from "./course"

Vue.use(vuex);

const actions = {};

/**
 * 返回工厂模式
 * @returns {Store<>}
 */
export default () => new Store({
  modules: {
    core,
    user,
    menu,
    wordfre,
    course
  },
  actions
})
